// authUserReducer.js

import {
  REMOVE_AUTHED_USER,
  RESET_STORE,
  SET_AUTHED_USER,
  UPDATE_AUTHED_USER,
} from "../actions/AuthUserActions";

const initialState = {
  isAuthenticated: false,
  user: null,
};

const authUserReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_AUTHED_USER:
      return {
        ...state,
        isAuthenticated: true,
        user: action.payload,
      };
    case REMOVE_AUTHED_USER:
      return initialState;
    case UPDATE_AUTHED_USER:
      return {
        ...state,
        user: { ...state.user, ...action.payload },
      };
    case RESET_STORE:
      return initialState;

    default:
      return state;
  }
};

export default authUserReducer;
